import React from 'react';
import {GridValidRowModel} from '@mui/x-data-grid-pro';
import {StickyDataGrid} from '../../../components/Common/StickyDataGrid';
import {useHardFacts} from '../../../hooks/useHardFacts';
import {ErrorPage} from '../../../pages/ErrorPage';
import {savingsColumns} from './SavingsInvestimentsColumns';

export const SavingsInvestimentsTable: React.FC = () => {
  const {data, error, loading} = useHardFacts();
  const savingsRows = data?.hardFacts?.assets ?? [];

  if (error) {
    return <ErrorPage text={error.message} />;
  }

  return (
    <StickyDataGrid
      sx={{
        overflowY: 'scroll',
        height: '250px',
      }}
      rowHeight={40}
      rows={savingsRows as readonly GridValidRowModel[]}
      columns={savingsColumns}
      hideFooter
      loading={loading}
    />
  );
};
